/**
 * Optional indication whether stub is shorter or longer than the regular swap period.
 * tag: 40874
 * @readonly
 * @enum {number} (int)
 */
export enum PaymentStubLength {
  /** Short */
  Short = 0,
  /** Long */
  Long = 1,
}
